import * as React from "react";
import { Box, Layer } from "grommet";
import ScrollContainer from "./ScrollContainer";

const StyledModal = ({ isOpen, setIsOpen, children }: { isOpen: boolean; setIsOpen?: Function; children: any }) => {
    if (isOpen)
        return (
            <Layer full="vertical" position="right" responsive={true} onEsc={() => setIsOpen && setIsOpen(false)} onClickOutside={() => setIsOpen && setIsOpen(false)}>
                <ScrollContainer direction={"-y"}>
                    <Box pad="medium">{children}</Box>
                </ScrollContainer>
            </Layer>
        );

    return <></>;
};

export default StyledModal;
